var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4246 36H5.84739C2.98042 36 0.635254 33.7666 0.635254 31.0362V4.96378C0.635254 2.23342 2.98042 0 5.84739 0H31.4231C34.2901 0 36.6353 2.23342 36.6353 4.96378V31.0348C36.6367 33.7666 34.2916 36 31.4246 36Z",
    fill: "url(#paint0_linear_374_674)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.036 5.14926C10.8944 5.21524 5.19141 10.8598 5.19141 17.6612C5.19141 17.8016 5.31522 17.9125 5.46263 17.904C6.66395 17.8324 7.85791 17.7552 9.05039 17.817V17.6359C9.05039 12.8729 13.0229 8.89736 18.0228 8.82437C23.1125 8.74996 27.2796 12.6721 27.2796 17.504V29.8586H31.1386V17.504C31.1386 10.6507 25.2484 5.08328 18.036 5.14926Z",
    fill: "url(#paint1_linear_374_674)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1643 5.14917C11.6668 5.14917 6.26892 9.72269 5.3344 15.6663V15.6677C5.31229 15.8053 5.2946 15.9443 5.27691 16.0832C5.27396 16.1043 5.27249 16.1253 5.26954 16.1464C5.25332 16.2882 5.23858 16.4314 5.22679 16.5746C5.22679 16.576 5.22679 16.5788 5.22679 16.5802C5.21647 16.7149 5.2091 16.8497 5.20321 16.9859C5.20173 17.0196 5.20026 17.0518 5.19879 17.0855C5.19436 17.2245 5.18994 17.3635 5.18994 17.5039V17.7678L5.19436 17.8281C5.35356 24.5101 11.1096 29.8585 18.1643 29.8585C21.3128 29.8585 24.2033 28.7847 26.4527 27.0019V21.1102C25.0126 24.1016 21.8405 26.1849 18.1643 26.1849C13.1718 26.1849 9.10494 22.3413 9.05187 17.5979C9.06367 17.5979 9.07399 17.5965 9.08578 17.5965C9.07399 17.5965 9.06219 17.5965 9.04893 17.5965V17.5039C9.04893 12.717 13.1379 8.82427 18.1628 8.82427C23.1877 8.82427 27.2781 12.7184 27.2781 17.5039V29.8585H31.1371V17.5039C31.1386 10.6913 25.3177 5.14917 18.1643 5.14917Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2798 5.14917V7.6451C29 9.08818 30.3399 10.9328 31.1388 13.0216V5.14917H27.2798Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_374_674",
    x1: 0.635254,
    y1: 0,
    x2: 43.9322,
    y2: 20.8398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229895,
    stopColor: "#834CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE45F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_374_674",
    x1: 5.19141,
    y1: 5.14868,
    x2: 35.8068,
    y2: 20.6224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229895,
    stopColor: "#834CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE45F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.311a21569906c26fdd9b8c0a5c53be98.svg";
export { ForwardRef as ReactComponent };